import { render } from "./PrivacyWave.vue?vue&type=template&id=6a30a5d4&scoped=true"
import script from "./PrivacyWave.vue?vue&type=script&lang=js"
export * from "./PrivacyWave.vue?vue&type=script&lang=js"

import "./PrivacyWave.vue?vue&type=style&index=0&id=6a30a5d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a30a5d4"]])

export default __exports__